import { render, staticRenderFns } from "./Aluminum.vue?vue&type=template&id=c23bfd2a&"
import script from "./Aluminum.vue?vue&type=script&lang=js&"
export * from "./Aluminum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports